'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _SearchBar = require('components/SearchBar/SearchBar');

var _SearchBar2 = _interopRequireDefault(_SearchBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./GroupContactsHeadLine.scss');

var GroupContactsHeadLine = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(GroupContactsHeadLine, _PureComponent);

  function GroupContactsHeadLine() {
    (0, _classCallCheck3.default)(this, GroupContactsHeadLine);
    return (0, _possibleConstructorReturn3.default)(this, (GroupContactsHeadLine.__proto__ || (0, _getPrototypeOf2.default)(GroupContactsHeadLine)).apply(this, arguments));
  }

  (0, _createClass3.default)(GroupContactsHeadLine, [{
    key: 'filter',
    value: function filter(kw) {
      var filter = this.props.filter;

      filter(kw);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          count = _props.count,
          kw = _props.kw;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.headLine, className) },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_SearchBar2.default, {
            kw: kw,
            onChange: this.filter
          })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.count },
          t('{{count}} contacts in group', { count: count })
        )
      );
    }
  }]);
  return GroupContactsHeadLine;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  count: _propTypes2.default.number,
  filter: _propTypes2.default.func,
  kw: _propTypes2.default.string
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'filter'), _class.prototype)), _class);
exports.default = GroupContactsHeadLine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupContacts/GroupContactsHeadLine/GroupContactsHeadLine.js
// module id = 2014
// module chunks = 1